// r10x-sandbox docker-compose implementation. PLACEHOLDER loopback URL (127.0.0.1:3021) until
// this deployment gets its own domain - matches the same pattern used for r10x-demo.
export const environment = {
  production: false,
  encryptSecretKey: 'r10x-dashboard-encrypt-key-sandbox',
  apiUrl: 'https://api.dev.retail10x.com/',
  cloud_storage_bucket: 'r10x-files',
  cloud_storage_folder_prefix: 'sandbox',
  cloud_storage_folder_coupons: 'coupons',
  cloud_storage_folder_tcb_coupons: 'tcb-coupons',
  cloud_storage_folder_circulars: 'circulars',
  cloud_storage_folder_sms_campaigns: 'sms_campaigns',
  cloud_storage_folder_push_notification_campaigns: 'push_notification_campaigns',
  apiErrorMessage: 'Error from server!',
  report_data_color: '#8C419C',
  compare_data_color: '#5FA1D3',
  default_chart_color: '#0DCAF0',
  default_chart_area_color: 'rgba(13,202,240,0.1)'
};
